import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as AdminActions from './admin.actions';
import { AccountClientService } from '@mode/shared/data-access-webapp';

@Injectable()
export class AdminEffects {
  loadAdmins$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AdminActions.loadAdmins),
      concatMap((action) => this.accountClient.getAdmins(action.username)),
      map((admins) => AdminActions.loadAdminsSuccess({ admins })),
      catchError((error) => of(AdminActions.loadAdminsFailure({ error })))
    );
  });

  constructor(
    private actions$: Actions,
    private accountClient: AccountClientService
  ) {}
}
